module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'buttons-panel' && templateVars.config ?
				templateVars.config :
				{
	"tourPlacement": "left",
	"tourWidth": 300,
	"tourYOffset": 0,
	"tourXOffset": 5,
	"ifEmptyPanel": "remove"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/buttons-panel/config.yaml
// module id = 87
// module chunks = 0